// Code generated by scripts/generate-product-categories.mjs; DO NOT EDIT.

export const PRODUCT_CATEGORIES = [
  {
    "id": "clothing",
    "label": "Clothing"
  },
  {
    "id": "tools",
    "label": "Tools"
  },
  {
    "id": "toys",
    "label": "Toys"
  },
  {
    "id": "home",
    "label": "Home"
  },
  {
    "id": "electronics",
    "label": "Electronics"
  },
  {
    "id": "kitchen",
    "label": "Kitchen"
  },
  {
    "id": "baby-and-kids",
    "label": "Baby & Kids"
  },
  {
    "id": "outdoors",
    "label": "Outdoors"
  },
  {
    "id": "food",
    "label": "Food"
  },
  {
    "id": "beauty",
    "label": "Beauty"
  },
  {
    "id": "pharmacy",
    "label": "Pharmacy"
  },
  {
    "id": "vacuum",
    "label": "Vacuum"
  },
  {
    "id": "cleaning",
    "label": "Cleaning"
  }
] as const;
export type ProductCategory = typeof PRODUCT_CATEGORIES[number]["id"];
const ids = new Set<string>(PRODUCT_CATEGORIES.map(category => category.id));
export const isProductCategory = (value: unknown): value is ProductCategory => typeof value === "string" && ids.has(value);
export const adjustedCategory = (product: { adjustedCategory?: string }): ProductCategory | "" =>
  isProductCategory(product.adjustedCategory) ? product.adjustedCategory : "";
export const matchesAdjustedCategories = (product: { adjustedCategory?: string }, selected?: ReadonlySet<string>): boolean =>
  selected === undefined || (adjustedCategory(product) !== "" && selected.has(adjustedCategory(product)));
export const adjustedCategoryCounts = (products: readonly { adjustedCategory?: string }[]) => {
  const counts = new Map<string, number>();
  for (const product of products) {
    const category = adjustedCategory(product);
    if (category) counts.set(category, (counts.get(category) ?? 0) + 1);
  }
  return PRODUCT_CATEGORIES.map(({ id }) => ({ id, count: counts.get(id) ?? 0 }));
};
export const categoryLabel = (id: string): string => PRODUCT_CATEGORIES.find(category => category.id === id)?.label ?? id;
// Clear old retailer labels while preserving each client's explicit empty-selection behavior.
export const migrateCategorySelection = (values: string[] | undefined): string[] | undefined => {
  if (values === undefined || values.length === 0 || (values.length === 1 && values[0] === "__none__")) return values;
  const valid = values.filter(isProductCategory);
  return valid.length ? [...new Set(valid)] : undefined;
};
